import { render, staticRenderFns } from "./feedbackBut.vue?vue&type=template&id=739def53&scoped=true"
import script from "./feedbackBut.vue?vue&type=script&lang=js"
export * from "./feedbackBut.vue?vue&type=script&lang=js"
import style0 from "./feedbackBut.vue?vue&type=style&index=0&id=739def53&prod&lang=scss&scoped=true"
import style1 from "./feedbackBut.vue?vue&type=style&index=1&id=739def53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739def53",
  null
  
)

export default component.exports